import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { AndroidWebAppInterface } from "src/app/core/Interfaces/AndroidWebInterface";
import { ConfiguracaoAndroid } from "src/app/core/modelos/Android/ConfiguracaoAndroid";
import { CustomersService } from "src/app/refact/pages/components/customers/services/customers.service";
import { TipoErro } from "src/app/refact/shared/components/erros/entities/TipoErro";
import { ErrosComponent } from "src/app/refact/shared/components/erros/erros.component";
import { environment as env } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private router = inject(Router);
  private customerService = inject(CustomersService);
  private http = inject(HttpClient);

  ambiente: any;
  acessoIndash: boolean = false;
  acessoAcompanhamento: boolean = false;
  acessoConsultaVendas: boolean = false;
  acessoPdvUP: boolean = false;
  ehAndroid: boolean = false;

  public setup(){
    this.verificarPlataforma();
    this.verificaPermissao();
  }

  setupAndRedirect(reirectTo?: string, erros?: ErrosComponent) {
    this.verificarPlataforma();
    this.verificaPermissao();
    this.setarConfiguracao(reirectTo, erros);
  }

  private verificarPlataforma(): void {
    try {
      if (Android && Android.ehAplicativo) {
        this.ehAndroid = true;
      }
    } catch (error) {
      this.ehAndroid = false;
    }
  }

  private setarConfiguracao(reirectTo?: string, erros?:ErrosComponent) {
    this.ambiente = JSON.parse(localStorage.getItem("ambiente"));
    let codigoFilial = this.ambiente?.filialUsuario?.codigo || "";

    this.customerService.getConfig().subscribe((data: any) => {
      if (data.data) {
        let configuracaoMalote = data.data.find(
          (x) =>
            x.configuracao.filial === codigoFilial &&
            x.configuracao.rede === localStorage.getItem("idCompany")
        );

        if (!configuracaoMalote) {
          configuracaoMalote = data.data.find(
            (x) =>
              x.configuracao.filial === "XX" &&
              x.configuracao.rede === localStorage.getItem("idCompany")
          );
        }

        const outrasConfig =
          configuracaoMalote?.configuracao?.outras ||
          "00000030001000100000000000010000000100000000000000010";

        localStorage.setItem("ConfigOutras", JSON.stringify(outrasConfig));
        if (reirectTo) {
          this.verificarWizard().then(wizardAtivo => {
            if (wizardAtivo) {
              localStorage.setItem("wizardPendente", "1");
              setTimeout(() => {
                window.location.href = '/configuracao-inicial';
              }, 1000);
            } else {
              localStorage.removeItem("wizardPendente");
              const finalRedirectPath = this.determineRedirectPath(reirectTo, erros);
              setTimeout(() => {
                window.location.href = finalRedirectPath;
              }, 1000);
            }
          });
        }
      }
    });

    try {
      if (Android && Android.ehAplicativo) {
        this.ehAndroid = true;
      }
    } catch (error) {}
  }

  private verificaPermissao() {
    const permissoes = JSON.stringify(localStorage.getItem("user_access"));

    if (!permissoes) {
      return;
    }

    if (!permissoes || permissoes[16] != "0") {
      this.acessoConsultaVendas = true;
    }

    if (!permissoes || permissoes[208] != "0") {
      this.acessoPdvUP = true;
    }

    if (!permissoes || permissoes[92] != "0") {
      this.acessoAcompanhamento = true;
    }

    if (!permissoes || permissoes[204] != "0") {
      this.acessoIndash = true;
    }
  }

  private async verificarWizard(): Promise<boolean> {
    try {
      const baseUrl = localStorage.getItem(env.baseApiModuleInfraStructure.toString());
      if (!baseUrl) return false;

      const response: any = await firstValueFrom(
        this.http.get(baseUrl + "api/v1/Configintegracao/Wizard")
      );

      if (response?.data && Array.isArray(response.data)) {
        const wizardConfig = response.data.find((c: any) => c.atributo === "ATIVAR");
        return wizardConfig?.valor2 == 1;
      }
      return false;
    } catch {
      return false;
    }
  }

  isWizardPending(): boolean {
    return localStorage.getItem("wizardPendente") === "1";
  }

  private determineRedirectPath(requestedPath: string, erros?:ErrosComponent): string {
    const configuracao = JSON.parse(localStorage.getItem("configuracao")) as ConfiguracaoAndroid;

    if (configuracao?.prevendaAutomatico) {
      return "/pre-venda";
    }

    if (!configuracao?.autoatendimentoAutomatico) {
        return requestedPath;
    }

    if (!this.canAccessKiosk()) {
      if(erros)
        erros.abrirModalPersonalizado(
          `O Autoatendimento não pode ser acessado.`,
          `Para utilizar esta funcionalidade, o usuário logado precisa ter em seu cadastro um vendedor vinculado. Configure em Menu > Administrativo > Usuários.`,
          TipoErro.BUSINESS_VIOLATION
        );
      return "/home";
    }

    if (!this.isAutoAtendimentoEnabled()) {
      return "/home";
    }

    return "/kiosk";
  }

  private canAccessKiosk(): boolean {
    return this.ambiente?.vendedorVinculado === true;
  }

  private isAutoAtendimentoEnabled(): boolean {
    try {
      const filialConfig = this.parseJsonSafely(this.ambiente?.filial?.configuracao);
      if (!filialConfig) return false;

      const autoAtendimento = this.parseJsonSafely(filialConfig.autoAtendimento);
      if (!autoAtendimento) return false;

      return autoAtendimento?.utilizaAutoAtendimento === "1";
    } catch (error) {
      console.warn('Erro ao verificar configuração de autoatendimento:', error);
      return false;
    }
  }

  private parseJsonSafely(jsonString: string): any {
    if (!jsonString) return null;
    
    try {
      return JSON.parse(jsonString);
    } catch (error) {
      console.warn('Erro ao fazer parse do JSON:', error);
      return null;
    }
  }
}

declare var Android: AndroidWebAppInterface;
